<template>
    <div class="member">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack"></Header>
        <div class="banner">
            <img src="../../../assets/img/b2b/banner_friendr@2x.png" alt="">
        </div>
        <div class="content">
            <div class="htop">
                <div class="title">我的<span>{{ memberList.length }}</span>个好友注册成功</div>
                <div class="code" v-show="invitationCode.keyManInvitationCode">专属邀请码：{{ invitationCode.keyManInvitationCode }}</div>
            </div>
            <div v-if="memberList.length">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finishText"
                    :immediate-check="false"
                    @load="onLoad"
                    >
                    <table class="table">
                        <thead>
                            <tr>
                                <th>会员账号</th>
                                <th>注册时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in memberList" :key="item.id">
                                <td>{{ phoneNumFilter(item.phone) }}</td>
                                <td>{{ item.createTime | formatDate }}</td>
                            </tr>
                        </tbody>
                    </table>
                </van-list>
            </div>
            <div v-else>
                <div class="empty">
                    <div class="img"><img src="../../../assets/img/b2b/imgs_empty@2x.png" alt=""></div>
                    <span>尚未有好友注册成功</span>
                </div>
            </div>
        </div>
        <div class="footer" @click="popupVisible = true">
            <span>立即邀请好友</span>
        </div>
        <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
            <div class="conpon">
                <div class="head f32 col333 textCenter">
                    请好友扫码一起来
                    <div class="close" @click="onClose()">
                        <img src="../../../assets/img/b2b/btn_delete@2x.png" alt="">
                    </div>
                </div>
                <div class="server">
                    <div class="erw">
                        <qrcode :url="qrConfig.url" :wid="qrConfig.width" :hei="qrConfig.height"></qrcode>
                    </div>
                    <div class="share">
                        <div class="title">点击分享邀请</div>
                        <div class="ul">
                            <div class="li">
                                <div class="img" @click="onWxShare"><img src="../../../assets/img/b2b/wx.png" alt=""></div>
                                <span>微信好友</span>
                            </div>
                            <div class="li" @click="onQqShare">
                                <div class="img"><img src="../../../assets/img/b2b/qq.png" alt=""></div>
                                <span>QQ好友</span>
                            </div>
                            <div class="li copy-btn" @click="copy" :data-clipboard-text="qrConfig.url">
                                <div class="img"><img src="../../../assets/img/b2b/lj.png" alt=""></div>
                                <span>复制链接</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mt-popup>
    </div>
</template>
<script>
import { versions } from '../../common/version'
import Header from '../../common/header'
import qrcode from 'vue_qrcodes'
import { getInvitationCode } from '../api/api'
import { Toast } from 'mint-ui'
import { phoneUrl } from '@/api/config'
import { mapActions } from 'vuex'
import Clipboard from 'clipboard'
export default {
    name: 'member',
    components: {
        Header,
        qrcode
    },
    data () {
        return {
            title: '我的好友推荐',
            titleRight: '',
            popupVisible: false,
            pageNumber: 1,
            pageSize: 10,
            total: 0,
            userInfo: '',
            memberList: [],
            invitationCode: '',
            code: '',
            loading: false,
            finished: false,
            paltform: '',
            finishText: '数据已加载完毕',
            qrConfig: {
                url: phoneUrl + '/b2b/drainageRegiste/regist?userId=' + this.$route.query.id + '&invitationCode=' + this.code, // 设置二维码内容或跳转地址
                width: 200,
                height: 200
            },
            shareTitle: '新手赢收益',
            logoUrl: 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20191031/508075c3-67ef-47bf-84d4-7409fddd69f0.png',
            shareUrl: phoneUrl + '/b2b/drainageRegiste/regist?userId=' + this.$route.query.id + '&invitationCode=' + this.code,
            content: '注册会员，购物享受批发价，邀请好友赚返利'
        }
    },
    methods: {
        ...mapActions(['setBuried', 'getMyMember']),
        onBack () {
            this.$router.go(-1)
        },
        onClose () {
            this.popupVisible = false
        },
        copy () {
            var clipboard = new Clipboard('.copy-btn')
            clipboard.on('success', e => {
                this.tracking(85)
                Toast({
                    message: '复制成功，请到聊天，短信，邮件中去黏贴',
                    duration: 2000
                })
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                Toast('该浏览器不支持自动复制')
                clipboard.destroy()
            })
        },
        tracking (event) {
            // 埋点数据
            this.setBuried({ dfx_type: 6, event: event, paltform: this.paltform })
        },
        onWxShare () {
            this.tracking(83)
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'wxShare',
                    'url': this.shareUrl,
                    'title': this.shareTitle,
                    'content': this.content,
                    'logoUrl': this.logoUrl
                })
            } else {
                window.kfxt.wxShare(this.shareUrl, this.shareTitle, this.content, this.logoUrl)
            }
        },
        onQqShare () {
            this.tracking(84)
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'qqShare',
                    'url': this.shareUrl,
                    'title': this.shareTitle,
                    'content': this.content,
                    'logoUrl': this.logoUrl
                })
            } else {
                window.kfxt.qqShare(this.shareUrl, this.shareTitle, this.content, this.logoUrl)
            }
        },
        phoneNumFilter (phone) {
            // 1字符串转化成数组
            let phoneArr = phone.split('')
            let phoneStr = ''
            // 2.将数组中的4-9位变成*
            phoneArr.map((res, index) => {
                if (index > 2 && index < 9) {
                    phoneStr += '*'
                } else {
                    phoneStr += res
                }
            })
            return phoneStr
        },
        onLoad () {
            this.pageNumber += 1
            this.init()
        },
        async init () {
            await this.getMyMember({
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                userId: this.$route.query.id
            }).then((data) => {
                this.memberList = this.memberList.concat(data.records)
                this.loading = false
                if (this.memberList.length >= data.total) {
                    this.finished = true
                }
                if (data.total < this.pageSize) {
                    this.finishText = ''
                }
            })
        },
        async getInvitationCodeData () {
            const { data } = await getInvitationCode({
                userId: this.userInfo.id
            })
            this.invitationCode = data
            this.code = data.keyManInvitationCode || data.merchantInvitationCode
            this.qrConfig.url = phoneUrl + '/b2b/drainageRegiste/regist?userId=' + this.userInfo.id + '&invitationCode=' + this.code
            this.shareUrl = phoneUrl + '/b2b/drainageRegiste/regist?userId=' + this.userInfo.id + '&invitationCode=' + this.code
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        if (versions().ios || versions().iPhone || versions().iPad) {
            this.paltform = 'ios'
        } else {
            this.paltform = 'android'
        }
        this.init()
        this.getInvitationCodeData()
    }
}
</script>
<style lang="scss" scoped>
    .member{
        height: calc(100% - 176px);
        background: #ffffff;
        overflow: auto;
        // padding-bottom: 200px;
        // min-height: 1000px;
        .banner{
            font-size: 0;
        }
        .content{
            padding: 0 32px;
            text-align: center;
            .htop{
                padding-bottom: 40px;
            }
            .title{
                font-size: 32px;
                color: #333333;
                padding-top: 40px;
                span{
                    font-size: 40px;
                    color: #FF7A45;
                    padding: 0 10px;
                }
            }
            .code{
                font-size: 28px;
                color: #666666;
                padding: 8px 0 0;
            }
            .empty{
                width: 280px;
                height: 280px;
                margin: 0 auto;
                .img{
                    font-size: 0;
                }
                span{
                    font-size: 28px;
                    color: #999999;
                    margin-top: 20px;
                    display: inline-block;
                }
            }
        }
        .footer{
            padding: 40px 32px;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            span{
                display: inline-block;
                width: 100%;
                height: 96px;
                line-height: 96px;
                text-align: center;
                border-radius: 96px;
                background: #FF7A45;
                color: #ffffff;
                font-size: 32px;
            }
        }
    }
    .table{
        border-collapse:collapse;
        width: 100%;
        thead>tr{
            background: #F8F8F8;
            height: 92px;
            line-height: 92px;
            color: #333333;
        }
        th,td {
            border: 2px solid #EBEBED;
            font-size: 28px;
            font-weight: normal;
        }
        .w{
            width:120px
        }
        tbody>tr{
            height: 88px;
            line-height: 88px;
            color: #999999;
            &:hover{
                background:#EBEBED;
            }
            td{
                padding:0 10px;
            }
        }
    }
    .mint-popup-bottom{
        width: 100%;
        background: #f5f5f5;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        .close{
            width: 48px;
            height: 48px;
            position: absolute;
            right: 24px;
            top: 10px;
        }
        .conpon{
            background: #ffffff;
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            .head{
                position: relative;
                height: 108px;
                line-height: 108px;
                padding: 0 24px;
            }
            .server{
                .erw{
                    width: 400px;
                    height: 400px;
                    padding-top: 80px;
                    padding-bottom: 130px;
                    margin: 0 auto;
                }
                .share{
                    border-top: 2px solid #D9D9D9;
                    .title{
                        text-align: center;
                        font-size: 32px;
                        color: #333333;
                        padding: 40px 0 80px;
                    }
                    .ul{
                        display: flex;
                        justify-content: space-around;
                        padding-bottom: 48px;
                        .li{
                            text-align: center;
                            font-size: 28px;
                            color: #999999;
                            .img{
                                width: 96px;
                                height: 96px;
                                margin: 0 auto;
                            }
                            span{
                                display: inline-block;
                                margin-top: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
    .loading {
        color: #999;
        text-align: center;
        padding: 40px;
    }
</style>
<style>
    .mint-toast.is-placemiddle{
        z-index: 9999;
    }
</style>
